import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ListItem1 from 'Components/ComponentLibrary/Components/ListItems/ListItem1';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import ListItemIcon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemIcon';
import SearchIcon from '@material-ui/icons/Search';
import useViewAllAccountsListItem from './useViewAllAccountsListItem';

const styles = () => ({
  root: {},
  listItemText: {},
});

const Content = ({
  className,
  classes,
  lineItemResource,
}) => {
  const { handleClick } = useViewAllAccountsListItem(lineItemResource);

  return (
    <ListItem1
      className={classNames(classes.root, className)}
      button
      onClick={handleClick}
      test={'balance-sheet-account-drawer-view-at-institution-action'}
    >
      <ListItemIcon>
        <SearchIcon />
      </ListItemIcon>
      <ListItemText1
        className={classes.listItemText}
        primary={'View All Accounts at Institution'}
        primaryTypographyProps={{
          variant: 'h5',
        }}
      />
    </ListItem1>
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lineItemResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
